import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Renders Uhe Organization Cell in the Tables
 * @param {object} content UheOrganizationCell Data
 * @returns {JSX.Element} Link
 */
const OrganizationCell = ({ content }) => {
  const { id, name } = content;

if(name == null) {
  return (
    <div className="uhe-table-td" title={name}>
      <Link to={`/configuration/organizations/edit/${id}`} title={name}>
        <span>{name}</span>
      </Link>
    </div>
  );
} else {
    return (
    <div className="uhe-table-td" title={name}>
      <Link to={`/configuration/organizations/edit/${id}`} title={name}>
        <span>{name}</span>
      </Link>
      <Link to={`/configuration/customers?topf_organization=${id}`} className="search-icon">
        <i className="icon icon-search-new" />
      </Link>
    </div>
  );
}
};

export default OrganizationCell;
